module.exports = __webpack_public_path__ + "img/arrow_right.4b616598.svg";